<template>

  <div class="container mt-5 w-100" id="profile-pricing" style="padding-top:98px;overflow-y:auto">
    <h4><strong>Recruitment Packages</strong></h4>
    <p>Ease your hiring with Hireclap hiring solutions</p>
    <table class="table table-bordered">
      <tr>
        <th v-for="p in packages" :key="p.package_id" :class="p.package_name == 'Premium' ? 'blue-col': ''" class="col-2" >
          <div>{{p.package_name}}</div>
          <div style="font-weight:100;font-size:0.75rem;font-style:italic">{{p.description}}</div>
        </th>
        <th>Custom packages</th>
      </tr>
      <tr v-for="index in feature_count" :key="index">
        <td v-for="p in packages" :key="p.package_id" :class="p.package_name == 'Premium' ? 'blue-col': ''">{{p.features[index-1]}}</td>
        <td :rowspan="feature_count + 3" v-if="index == 1">
          <p>If your hiring needs are higher  / need a custom package?</p>
          <p>Happy to support you - Contact <a href="mailto:recruit@hireclap.com">recruit@hireclap.com</a> / 9037156256</p>
        </td>
      </tr>
      <tr>
        <td v-for="p in packages" :key="p.package_id" :class="p.package_name == 'Premium' ? 'blue-col': ''">
          <div v-if="p.package_name == 'Free'">Unlimited days</div>
          <div v-else>{{p.validity_days}} days</div>
        </td>
      </tr>
      <tr>
        <td v-for="p in packages" :key="p.package_id" :class="p.package_name == 'Premium' ? 'blue-col': ''">
          <div>{{p.support}}</div>
        </td>
      </tr>
      <tr>
        <td v-for="p in packages" :key="p.package_id" :class="p.package_name == 'Premium' ? 'blue-col': ''">
          <div v-if="p.package_name == 'Free'">
            <div>Free</div>
            <button class="btn btn-primary mt-3" style="border-radius:0" v-if="!$cookies.get('hire-employer')"><a style="color:#fff;text-decoration:none" href="/recruit/register" target="_blank">Register</a></button>
          </div>
          <div v-else>
            <div>INR {{p.package_amount}}/- + GST</div>
            <button class="btn btn-primary mt-3" style="border-radius:0" @click="gotoPayment(p)">Buy now</button>
          </div>
        </td>
      </tr>
    </table>
    <div class="col-lg-10 mx-auto notes">
      <p class="mb-0"><strong>Notes</strong></p>
      <div>*Applications are subject to the attractiveness of your job opportunity</div>
      <div>**Access candidates contact details, resume,visume & full profile at Hireclap.com. You can do various candidate search option and can unlock profiles as per your interest</div>
      <div>A detailed job description with all necessary information will attract more applications</div>
      <div>Respond to the applications quickly for better conversion</div>
      <div>Asking for any kind of payment is strictly prohibited</div>
      <div>Video profile access of the applicants / candidates (If the candidate updated the video profile)</div>
      <div>GST 18% additional applicable for all packages mentioned above</div>
      <div>Refund option is available as per the <a href="/recruit/refund-policy">refund policy</a></div>
    </div>
  </div>
</template>

<script>
export default {
  name:"package_pricing",
  beforeMount() {
    this.loadPackages();
  },
  data() {
    return {
      packages: [],
      feature_count: 0,
    };
  },
  methods:{
    loadPackages: function() {
      new this.$apiAction().packagePricing().then((res) => {
          if(res.status == true) {
             this.packages = res.packages;
             this.feature_count = this.packages[0].features.length;
          }
      }).catch((err) => {
          console.log(err)
      });
    },
    gotoPayment(p) {
      // let products = [];
      let descriptions = [];
      p.features.forEach(f => {
        descriptions.push(f);
      });
      descriptions.push(p.validity_days + ' days validity')
      let product = {
        package_id: p.id,
        name : p.package_name,
        price: p.package_amount,
        tax: p.tax_amount,
        description: descriptions
      }
      // products.push(product);
      if(this.$cookies.get("hire-employer")) {
        this.$router.push({
          name: 'payment',
          params: { product: product, type: 'packages'}
        });
      } else {
        this.$router.push({
          name: 'rec_login',
          params: { redirect_to: '/recruit/package-pricing'}
        });
      }
    }
  }

}
</script>
<style>
  .feature-list ul {
    background-color: #e1f9f9;
    padding: 0.5rem;
    margin-bottom: 0;
  }
  .feature-list ul:nth-child(2n+1) {
    background-color: #fff;
  }
</style>
